import getFolderTable from '../../selectors/getFolderTable';
import type { MailFolder } from 'owa-graph-schema';
import type * as Schema from 'owa-graph-schema';

/**
 * Creates the Folder by adding client specific properties
 *
 * @param rawFolder Folder object
 * @param principalSMTPAddress Account to which the folder belongs
 */
export function createOrGetFolder(
    rawFolder: Schema.MailFolder,
    principalSMTPAddress: string
): MailFolder {
    if (getFolderTable().has(rawFolder.id)) {
        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS2322 (19,9): Type 'MailFolder | undefined' is not assignable to type 'MailFolder'.
        // @ts-expect-error
        return getFolderTable().get(rawFolder.id);
    }

    return {
        childFolderIds: [],
        principalSMTPAddress: principalSMTPAddress,
        ...rawFolder,
    };
}
